import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const useFetchData = (fetchFunction, id, initialFormState, lang) => {
    const [formStateById, setFormStateById] = useState(initialFormState);
    const [fetching, setIsfetching] = useState(false);
    const [fetchError, setFetchError] = useState(null);
    const model = 'advertisement'
    useEffect(() => {
        const fetchData = async () => {
            setIsfetching(true);
            try {
                const response = await fetchFunction(id);
                const mainDataObject = response.data[model];
                const updatedFormState = {
                    id: mainDataObject.id,
                    name: mainDataObject.name,
                    file_path_small: mainDataObject.file_path_small,
                    file_path_large: mainDataObject.file_path_large,
                    servicepoint_ids: mainDataObject?.servicepoints,
                    forward: mainDataObject.forward,
                    file_type: mainDataObject.file_type,
                    play_time: mainDataObject.play_time,
                }
                setFormStateById(updatedFormState)
                
            } catch (err) {
                toast.error(`Error: ${err.message}`);
                setFetchError(err.message);
            } finally {
                setIsfetching(false);
            }
        };

        fetchData();
    }, []);
   
    return { formStateById, setFormStateById, fetching, fetchError };
};
export default useFetchData;
